import { Asset } from '../../api';

export type SearchShape = {
  text: string;
  options: {
    searchInLayers: boolean;
    searchInArchives: boolean;
    searchWithAi: boolean;
  };
  uploadData: UploadData | undefined;
  similarAsset: Pick<Asset, 'id' | 'name'> | undefined; // содержит информацию об ассете-референсе, пока не получен search_upload_id
};

export type UploadData = {
  id: number;
  fileName: string;
  similarAssetId?: Asset['id'];
};

// Нужны mime types, т.к. во время перетаскивания файла мы не можем получить его extension.
export const ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
// Нужны extensions, когда опираемся на информацию о preview.
export const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp'];

export const getAllowedTransferItem = (dt: DataTransfer | null): DataTransferItem | null => {
  if (!dt || !dt.types.includes('Files')) {
    return null;
  }
  const fileItems = Array.from(dt.items).filter((item) => item.kind === 'file');
  if (fileItems.length !== 1) {
    return null;
  }
  const item = fileItems[0];
  const mime = item.type.toLowerCase();
  if (!ALLOWED_MIME_TYPES.includes(mime)) {
    return null;
  }
  return item;
};
